// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".speed-dial-demo[data-v-05fcd578] {\n  display: flex;\n  align-items: center;\n}\n.speed-dial-demo > div[data-v-05fcd578] {\n  width: 25%;\n}\n.speed-dial-demo[data-v-05fcd578]  .custom-button {\n  color: #222;\n  background-color: #DDD;\n}\n.speed-dial-demo[data-v-05fcd578]  .custom-title {\n  color: #555;\n  background-color: #F1F1F1;\n}", ""]);
// Exports
module.exports = exports;
